import React from 'react'
import { useRouter } from 'next/navigation'

import type { StepType } from './types'

type StepProps = StepType & {
  stepNumber: number
}

const Step: React.FC<StepProps> = ({
  id,
  title,
  description,
  stepNumber,
  image,
}: StepProps) => {
  const router = useRouter()

  const onClick = () => {
    router.push('/retailers')
  }

  return (
    <div
      className="my-5 flex flex-col justify-between gap-10 py-5 lg:my-10 lg:flex-row lg:py-10"
      key={id}
    >
      <div className="flex flex-col gap-5">
        <div className="flex h-12 w-12 items-center justify-center rounded-full bg-tenant-primary-color font-bold text-white">
          {stepNumber}
        </div>
        <div className="mt-5 text-3xl font-semibold">{title}</div>
        <div className="text-base text-gray-600">{description}</div>
      </div>

      <div
        className="h-[335px] w-full shrink-0 cursor-pointer lg:w-[458px]"
        onClick={onClick}
      >
        {image?.file?.url ? (
          <img
            alt={image?.title ?? `step-${id}-${stepNumber}`}
            src={image?.file?.url}
            className="h-full w-full rounded-md object-cover"
          />
        ) : (
          <div className="h-full w-full rounded-md bg-tenant-primary-color"></div>
        )}
      </div>
    </div>
  )
}

export { Step }
